import { stats } from "@/mocks/home";
import { useEffect, useRef, useState } from "react";

export default function HomeStats() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="relative -mt-12 z-20 pb-6">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div ref={ref} className="bg-background-50 rounded-2xl grid grid-cols-2 md:grid-cols-4 divide-x divide-background-200/60 overflow-hidden">
          {stats.map((stat, i) => (
            <div key={stat.label} className="px-4 py-6 md:py-8 text-center">
              <div className={`font-heading font-bold text-2xl md:text-3xl text-primary-500 mb-1 transition-all duration-700 delay-${i * 150} ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}